import React, {useState, useEffect} from 'react';
import apiInstance from '../../utils/axios';
import UserData from '../plugin/UserData';
import { Link } from 'react-router-dom';
import Slidebar from './Slidebar';
import moment from 'moment';
import './style/customer-dashboard.css';


function Orders() {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const userData = UserData();

    useEffect(() => {
        if (userData?.user_id) {
            setLoading(true);
            setError(null);
            
            apiInstance.get(`customer/orders/${userData.user_id}/`)
                .then((res) => {
                    // Handle both direct array and paginated response
                    const ordersData = Array.isArray(res.data) ? res.data : (res.data.results || []);
                    
                    setOrders(ordersData);
                    setLoading(false);
                })
                .catch((error) => {
                    console.error('Error fetching orders:', error);
                    console.error('Error response:', error.response?.data);
                    setError("Error al cargar los pedidos. Por favor, inténtalo de nuevo.");
                    setLoading(false);
                });
        } else {
            setLoading(false);
            setError("Usuario no autenticado. Por favor, inicia sesión.");
        }
    }, [userData?.user_id])

    
    const statusCounts = Array.isArray(orders) ? orders.reduce((counts, order) => {
      const status = order.order_status
      counts[status] = (counts[status] || 0) + 1
      return counts
    }, {}) : {}
    



    return (
        <div className="customer-dashboard">
            {loading && (
                <div className="container text-center py-5">
                    <div className="spinner-border loading-spinner" role="status">
                        <span className="visually-hidden">Cargando...</span>
                    </div>
                    <p className="mt-3">Cargando tus pedidos...</p>
                </div>
            )}

            {error && (
                <div className="container text-center py-5">
                    <div className="alert alert-danger error-alert shadow-sm" role="alert">
                        <i className="fas fa-exclamation-triangle me-2"></i>
                        {error}
                    </div>
                    <button 
                        className="btn btn-primary mt-3"
                        onClick={() => window.location.reload()}
                    >
                        <i className="fas fa-sync-alt me-2"></i> Intentar de Nuevo
                    </button>
                </div>
            )}

            {!loading && !error && (
                <main className="mt-4 mt-md-5">
                    <div className="container">
                        <section className="">
                            <div className="row g-4">
                                <div className="col-12 d-md-none">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <h3 className="mb-0">
                                            <i className="fas fa-shopping-cart text-primary" /> Pedidos
                                        </h3>
                                        <button 
                                            className="btn btn-outline-primary btn-sm"
                                            onClick={() => window.location.reload()}
                                            title="Actualizar pedidos"
                                        >
                                            <i className="fas fa-sync-alt"></i>
                                        </button>
                                    </div>
                                </div>
                                
                                <Slidebar />

                                <div className="col-lg-9 col-md-12">
                                    <div className="d-none d-md-flex justify-content-between align-items-center mb-4">
                                        <h3 className="mb-0">
                                            <i className="fas fa-shopping-cart text-primary" /> Pedidos
                                        </h3>
                                        <button 
                                            className="btn btn-outline-primary btn-sm"
                                            onClick={() => window.location.reload()}
                                            title="Actualizar pedidos"
                                        >
                                            <i className="fas fa-sync-alt me-2"></i> Actualizar
                                        </button>
                                    </div>

                                    {/* Stats Cards */}
                                    <div className="row g-3 mb-4">
                                        <div className="col-12 col-sm-6 col-lg-4">
                                            <div className="card stats-card border-0 shadow-sm h-100 depth-2">
                                                <div className="card-body p-4">
                                                    <div className="d-flex align-items-center">
                                                        <div className="flex-grow-1">
                                                            <p className="mb-1 text-muted small fw-medium">Total de Pedidos</p>
                                                            <h2 className="mb-0 text-dark fw-bold">{Array.isArray(orders) ? orders.length : 0}</h2>
                                                        </div>
                                                        <div className="ms-3">
                                                            <div className="p-3 rounded-circle" style={{ backgroundColor: "#e3f2fd", width: "60px", height: "60px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                                <i className="fas fa-shopping-cart fs-4" style={{ color: "#1976d2" }}></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div className="col-12 col-sm-6 col-lg-4">
                                            <div className="card stats-card border-0 shadow-sm h-100 depth-2">
                                                <div className="card-body p-4">
                                                    <div className="d-flex align-items-center">
                                                        <div className="flex-grow-1">
                                                            <p className="mb-1 text-muted small fw-medium">Pendiente de Entrega</p>
                                                            <h2 className="mb-0 text-dark fw-bold">{statusCounts.pending || 0}</h2>
                                                        </div>
                                                        <div className="ms-3">
                                                            <div className="p-3 rounded-circle" style={{ backgroundColor: "#fff8e1", width: "60px", height: "60px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                                <i className="fas fa-clock fs-4" style={{ color: "#f57c00" }}></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div className="col-12 col-sm-6 col-lg-4">
                                            <div className="card stats-card border-0 shadow-sm h-100 depth-2">
                                                <div className="card-body p-4">
                                                    <div className="d-flex align-items-center">
                                                        <div className="flex-grow-1">
                                                            <p className="mb-1 text-muted small fw-medium">Completado</p>
                                                            <h2 className="mb-0 text-dark fw-bold">{statusCounts.fulfilled || 0}</h2>
                                                        </div>
                                                        <div className="ms-3">
                                                            <div className="p-3 rounded-circle" style={{ backgroundColor: "#f1f8e9", width: "60px", height: "60px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                                <i className="fas fa-check-circle fs-4" style={{ color: "#388e3c" }}></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Orders Table */}
                                    <div className="card border-0 shadow-sm depth-2">
                                        <div className="card-header bg-white border-0 py-3">
                                            <h5 className="mb-0 text-dark fw-semibold">
                                                <i className="fas fa-list me-2 text-primary"></i>
                                                Historial de Pedidos
                                            </h5>
                                        </div>
                                        <div className="card-body p-0">
                                            <div className="table-responsive">
                                                <table className="table table-hover mb-0">
                                                    <thead className="bg-light">
                                                        <tr>
                                                                                                                         <th className="border-0 text-muted fw-semibold px-4 py-3">ID del Pedido</th>
                                                             <th className="border-0 text-muted fw-semibold px-4 py-3 d-none d-md-table-cell">Método de Pago</th>
                                                             <th className="border-0 text-muted fw-semibold px-4 py-3 d-none d-md-table-cell">Estado del Pago</th>
                                                             <th className="border-0 text-muted fw-semibold px-4 py-3 d-none d-md-table-cell">Estado del Pedido</th>
                                                             <th className="border-0 text-muted fw-semibold px-4 py-3">Total</th>
                                                             <th className="border-0 text-muted fw-semibold px-4 py-3">Acciones</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                                                        {Array.isArray(orders) && orders.length > 0 ? (
                                    orders.map((o, index) => (
                                                                <tr key={index} className="border-bottom fade-in">
                                                                                                                                         <td className="px-4 py-3">
                                                                         <div>
                                                                             <p className="fw-bold mb-1 text-dark">#{o.oid}</p>
                                                                             <p className="text-muted mb-0 small">{moment(o.date).format('MMM DD, YYYY')}</p>
                                                                         </div>
                                                                     </td>
                                                                     <td className="px-4 py-3 d-none d-md-table-cell">
                                                                         <span className={`badge rounded-pill px-3 py-2 ${
                                                                             o.payment_method === 'whatsapp' ? 'bg-success' : 'bg-primary'
                                                                         }`}>
                                                                             {o.payment_method === 'whatsapp' ? '📱 WhatsApp' : '💳 Stripe'}
                                                                         </span>
                                                                     </td>
                                                                     <td className="px-4 py-3 d-none d-md-table-cell">
                                                                         <span className={`badge rounded-pill px-3 py-2 ${
                                                                             o.payment_status === 'paid' ? 'bg-success' : 
                                                                             o.payment_status === 'pending' ? 'bg-warning' : 
                                                                             o.payment_status === 'processing' ? 'bg-info' : 'bg-secondary'
                                                                         }`}>
                                                                             {o.payment_status.toUpperCase()}
                                                                         </span>
                                                                     </td>
                                                                    <td className="px-4 py-3 d-none d-md-table-cell">
                                                                        <span className={`badge rounded-pill px-3 py-2 ${
                                                                            o.order_status === 'fulfilled' ? 'bg-success' : 
                                                                            o.order_status === 'pending' ? 'bg-warning' : 
                                                                            o.order_status === 'cancelled' ? 'bg-danger' : 'bg-secondary'
                                                                        }`}>
                                                                            {o.order_status}
                                                                        </span>
                                                                    </td>
                                                                    <td className="px-4 py-3">
                                                                        <span className="fw-bold text-dark fs-6">${o.total}</span>
                                                                    </td>
                                                                    <td className="px-4 py-3">
                                                                        <div className="d-flex flex-column flex-sm-row gap-2">
                                                                            <Link className="btn btn-outline-primary btn-sm" to={`/customer/orders/${o.oid}/`}>
                                                                                <i className="fas fa-eye me-1" /> Ver
                                                                            </Link>
                                                                            <Link className="btn btn-outline-secondary btn-sm" to={`/customer/invoice/${o.oid}/`}>
                                                                                <i className="fas fa-file-invoice me-1" /> Factura
                                                                            </Link>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                                                                                         <tr>
                                                                 <td colSpan="6" className="text-center py-5">
                                                                    <div className="empty-state">
                                                                        <div className="empty-state-icon">
                                                                            <i className="fas fa-shopping-cart fa-2x"></i>
                                                                        </div>
                                                                        <h5 className="mb-2 text-dark">No se encontraron pedidos</h5>
                                                                        <p className="text-muted mb-3">¡Comienza a comprar para ver tus pedidos aquí!</p>
                                                                        <Link to="/" className="btn btn-primary">
                                                                            <i className="fas fa-shopping-bag me-2"></i>
                                                                            Comenzar a Comprar
                                                                        </Link>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                                                         {/* Mobile Order Cards for small screens */}
                                     <div className="d-md-none mt-4">
                                         {Array.isArray(orders) && orders.length > 0 && (
                                             <div className="row g-3">
                                                 {orders.map((o, index) => (
                                                    <div key={index} className="col-12">
                                                        <div className="card mobile-order-card border-0 shadow-sm depth-1 slide-up">
                                                            <div className="card-body p-4">
                                                                                                                                 <div className="d-flex justify-content-between align-items-start mb-3">
                                                                     <div>
                                                                         <h6 className="fw-bold text-dark mb-1">#{o.oid}</h6>
                                                                         <p className="text-muted small mb-0">{moment(o.date).format('MMM DD, YYYY')}</p>
                                                                     </div>
                                                                     <span className="fw-bold text-dark fs-6">${o.total}</span>
                                                                 </div>
                                                                 
                                                                 <div className="row g-2 mb-3">
                                                                     <div className="col-4">
                                                                         <span className={`badge rounded-pill px-2 py-2 w-100 ${
                                                                             o.payment_method === 'whatsapp' ? 'bg-success' : 'bg-primary'
                                                                         }`}>
                                                                             {o.payment_method === 'whatsapp' ? '📱 WhatsApp' : '💳 Stripe'}
                                                                         </span>
                                                                     </div>
                                                                     <div className="col-4">
                                                                         <span className={`badge rounded-pill px-2 py-2 w-100 ${
                                                                             o.payment_status === 'paid' ? 'bg-success' : 
                                                                             o.payment_status === 'pending' ? 'bg-warning' : 
                                                                             o.payment_status === 'processing' ? 'bg-info' : 'bg-secondary'
                                                                         }`}>
                                                                             {o.payment_status.toUpperCase()}
                                                                         </span>
                                                                     </div>
                                                                     <div className="col-4">
                                                                         <span className={`badge rounded-pill px-2 py-2 w-100 ${
                                                                             o.order_status === 'fulfilled' ? 'bg-success' : 
                                                                             o.order_status === 'pending' ? 'bg-warning' : 
                                                                             o.order_status === 'cancelled' ? 'bg-danger' : 'bg-secondary'
                                                                         }`}>
                                                                             {o.order_status}
                                                                         </span>
                                                                     </div>
                                                                 </div>
                                                                
                                                                <div className="d-flex gap-2">
                                                                    <Link className="btn btn-outline-primary btn-sm flex-fill" to={`/customer/orders/${o.oid}/`}>
                                                                        <i className="fas fa-eye me-1" /> View
                                                                    </Link>
                                                                    <Link className="btn btn-outline-secondary btn-sm flex-fill" to={`/customer/invoice/${o.oid}/`}>
                                                                        <i className="fas fa-file-invoice me-1" /> Invoice
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </main>
            )}
        </div>
    );
}

export default Orders;